export default __webpack_public_path__ + "static/media/58_photo.5b9b771d.jpg";